import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-gordita-medium text-[16px] text-Text/text_high leading-[18px] top-[19px] absolute" }, "Daily Active Helper Machines", -1)

import { IncrediCard, IncrediChartBar } from 'incredi-ui';
import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dataZoomSliderOff } from '@/views/dashboard/dashboard.charts.utils';
import dashboardNoData from '@/views/dashboard/components/dashboard-no-data.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'daily-active-helper-machines',
  props: {
    noData: { type: Boolean },
    chartOptions: null
  },
  setup(__props: any) {

const props = __props as {
  noData?: boolean;
  chartOptions: InstanceType<typeof IncrediChartBar>['$props'];
}


const chartProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...rest } = props.chartOptions;

  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "h-full relative p-[16px] !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _hoisted_1,
          (__props.noData)
            ? (_openBlock(), _createBlock(dashboardNoData, {
                key: 0,
                class: "mt-[16px]",
                icon: "no_data",
                card: false,
                title: "No Helpers Used"
              }))
            : (_openBlock(), _createBlock(_unref(IncrediChartBar), _mergeProps({
                key: 1,
                height: "284px",
                options: {
          dataZoom: _unref(dataZoomSliderOff),
          ...(__props.chartOptions.options || {}),
        }
              }, _unref(chartProps)), null, 16, ["options"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})